import React from 'react'
import LinkedIn from '../../images/linkedIn-logo.jpg';

function LinkedInConnect() {
    return (
        <section className="container my-5">
            <div className="row g-0 overflow-hidden shadow rounded">
                {/* Left 70% Content */}
                <div
                    className="col-12 col-md-8 p-4 d-flex flex-column justify-content-center text-white rounded-start"
                    style={{
                        background: 'linear-gradient(135deg, #275E76, #49A3DA)',
                        boxShadow: '0 20px 25px rgba(0, 0, 0, 0.6)', // enhanced shadow
                        borderTopLeftRadius: '0.75rem',
                        borderBottomLeftRadius: '0.75rem',
                    }}
                >
                    <h1 className="fw-bold mb-3" ><b>Let’s Get in Touch!</b></h1>
                    <h5 className="mb-4">
                        Our team is ready to discuss your next big idea and help execute your project. We are here to bring your vision to life.
                    </h5>
                    <a href="https://www.linkedin.com/company/peregrinee/" target='_blank' className="btn custom-orange-btn py-2 px-5 fw-bold mt-3 btn btn-light rounded-pill px-4 py-2 fw-bold align-self-start">
                        Connect with us on LinkedIn
                    </a>
                </div>


                {/* Right 30% Image */}
                <div className="col-12 col-md-4">
                    <img
                        src={LinkedIn}
                        alt="Descriptive Alt"
                        className="img-fluid w-100 h-100 object-fit-cover"
                    />
                </div>
            </div>
        </section>

    )
}

export default LinkedInConnect